import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import FilterSelect from './FilterSelect';
import { getYearsApartInArray } from '../utilities/Sorting';

class TrialSearch extends Component {
  constructor(props) {
    super(props);
    const { data } = props;
    const {
      query, showDeactivatedTrials, tags, year,
    } = data;
    this.state = {
      searchQuery: query || '',
      searchDeactivatedTrials: showDeactivatedTrials,
      tags: tags.length ? tags : [],
      year,
    };
  }

  submitOnEnter = (e) => {
    if (e.key === 'Enter') {
      this.props.onSearch(this.state);
    }
  };

  render() {
    const {
      onSearch,
      hideYearFilter,
      trialTags,
    } = this.props;

    const options = Object.keys(trialTags).map((key) => ({
      value: parseInt(key, 10),
      displayValue: trialTags[key].name,
    }));

    const {
      searchQuery, tags, year: stateYear, showDeactivatedTrials,
    } = this.state;
    const { onShowDeactivatedTrials, onShowDeactivatedTrialsLabel } = this.props;
    return (
      <>
        <div className="flex items-center nowrap">
          <TextField
            id="TrialSearch-input"
            className="basis-100 mr3"
            label={<FormattedMessage id="trials.searchHeading" />}
            // placeholder={<FormattedMessage id="trials.searchHint" />}
            value={searchQuery}
            onChange={(e) => {
              this.setState({ searchQuery: e.target.value }, () => {
                if (searchQuery === '') {
                  onSearch({ searchQuery: '', tags });
                }
              });
            }}
            onKeyPress={this.submitOnEnter}
            variant="standard"
          />
          <FilterSelect
            id="TrialSearchType-tagselect"
            options={options}
            value={tags}
            label={<FormattedMessage id="trials.tag" />}
            onChange={(tagIds) => {
              const tagIdsInNumber = tagIds.map((id) => parseInt(id, 10));
              this.setState({ tags: tagIdsInNumber }, () => onSearch(this.state));
            }}
            multiple
          />
          <FilterSelect
            id="TrialSearchType-yearselect"
            options={getYearsApartInArray()}
            value={stateYear}
            label={<FormattedMessage id="trialSearch.yearSelectHeading" />}
            onChange={(year) => this.setState(
              { year },
              () => onSearch(this.state),
            )}
            hide={hideYearFilter}
          />
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              id="TrialSearch-submit"
              onClick={() => onSearch(this.state)}
              color="primary"
            >
              <FormattedMessage id="trials.searchButtonLabel" />
            </Button>
            {
              (searchQuery.length > 0 || tags.length > 0)
              && (
                <Button
                  variant="contained"
                  onClick={() => {
                    this.setState(
                      { searchQuery: '', tags: [], year: moment().utc().format('YYYY') },
                      () => onSearch(this.state),
                    );
                  }}
                  color="primary"
                >
                  <FormattedMessage id="trials.resetButtonLabel" />
                </Button>
              )
            }
          </Box>
        </div>
        {onShowDeactivatedTrials
          && (
            <div>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={showDeactivatedTrials}
                    onChange={(event) => {
                      this.setState(
                        { searchDeactivatedTrials: event.target.checked },
                        () => onShowDeactivatedTrials(event.target.checked),
                      );
                    }}
                    color="primary"
                  />
                )}
                label={<FormattedMessage id={onShowDeactivatedTrialsLabel || 'trials.showDeactivateTrials'} />}
              />
            </div>
          )}
      </>
    );
  }
}

TrialSearch.defaultProps = {
  data: {},
  onShowDeactivatedTrials: undefined,
  onShowDeactivatedTrialsLabel: undefined,
  hideYearFilter: false,
  trialTags: {},
};

TrialSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  data: PropTypes.shape({
    year: PropTypes.string,
    query: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.number),
    showDeactivatedTrials: PropTypes.bool,
    onShowDeactivatedTrialsLabel: PropTypes.string,
  }),
  onShowDeactivatedTrials: PropTypes.func,
  onShowDeactivatedTrialsLabel: PropTypes.string,
  hideYearFilter: PropTypes.bool,
  trialTags: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      tagId: PropTypes.number,
    }),
  ),
};

export default TrialSearch;
